import React, { useEffect } from 'react'
import { useAppFormHandler } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { useComputed } from '@preact/signals-react'
import { formData } from '@signals'
import { object, array } from 'yup'


export default function CompanySelector() {
	const mustHide = useComputed(() => !formData.value?.showCompany)
	const { companies, onCompaniesChange, error } = useAppFormHandler('companies', mustHide.value ? object({}) : object({ companies: array().min(1,'Must provide a company') }))

	useEffect(() => {
		onCompaniesChange([])
	}, [mustHide.value])

	if(mustHide.value) return null

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/companies`}
		placeholder="Companies"
		value={companies || []}
		onChange={e => onCompaniesChange(e.target.value)}
		multiple
		error={error}
	/>

}